// extracted by mini-css-extract-plugin
export default {"searchTopics":"SearchTopics_searchTopics__2+it1","title":"SearchTopics_title__o8koj","searchWrapper":"SearchTopics_searchWrapper__ZBGvj","search":"SearchTopics_search__OS4+A"};